export enum PromotionType {
  DISCOUNT_NOT_MIX = "DISCOUNT_NOT_MIX",
  FREEBIES_NOT_MIX = "FREEBIES_NOT_MIX",
  DISCOUNT_MIX = "DISCOUNT_MIX",
  FREEBIES_MIX = "FREEBIES_MIX",
  OTHER = "OTHER",
  DISCOUNT_NOT_MIX_SET = "DISCOUNT_NOT_MIX_SET",
  DISCOUNT_MIX_RANGE = "DISCOUNT_MIX_RANGE",
}

export const PROMOTION_TYPE_NAME: any = {
  DISCOUNT_NOT_MIX: "ส่วนลดแบบไม่คละ SKU",
  DISCOUNT_NOT_MIX_SET: "ส่วนลดแบบไม่คละ SKU กำหนดตามจำนวนชุด",
  DISCOUNT_MIX: "ส่วนลดแบบคละ SKU",
  DISCOUNT_MIX_RANGE: "ส่วนลดแบบคละ SKU กำหนดตามช่วงจำนวน",
  FREEBIES_NOT_MIX: "ของแถมแบบไม่คละ SKU",
  FREEBIES_MIX: "ของแถมแบบคละ SKU",
  OTHER: "อื่น ๆ",
};

export const PromotionGroup = {
  NOT_MIX: [
    PromotionType.DISCOUNT_NOT_MIX,
    PromotionType.FREEBIES_NOT_MIX,
    PromotionType.DISCOUNT_NOT_MIX_SET,
  ],
  MIX: [
    PromotionType.DISCOUNT_MIX,
    PromotionType.FREEBIES_MIX,
    PromotionType.OTHER,
    PromotionType.DISCOUNT_MIX_RANGE,
  ],
};

export enum PromotionGroupOption {
  UNIT = "Quantity",
  WEIGHT = "Size",
}

export const PROMOTION_GROUP_OPTION_NAME = {
  UNIT: "จำนวน",
  WEIGHT: "น้ำหนัก/ปริมาตร",
};

export const PromotionStatus = [
  { key: "DISCOUNT_NOT_MIX", label: "ส่วนลดแบบไม่คละ SKU", value: "DISCOUNT_NOT_MIX" },
  { key: "FREEBIES_NOT_MIX", label: "ของแถมแบบไม่คละ SKU", value: "FREEBIES_NOT_MIX" },
  { key: "DISCOUNT_MIX", label: "ส่วนลดแบบคละ SKU", value: "DISCOUNT_MIX" },
  { key: "FREEBIES_MIX", label: "ของแถมแบบคละ SKU", value: "FREEBIES_MIX" },
  { key: "OTHER", label: "อื่นๆ", value: "OTHER" },
];
